<template>
  <div class="exchange-container">
    <div class="information-box">
      <BaseInfo :title="getPageTitle" :form="baseInfoFormData" :form-data="customer" :form-data-detail="detail" />
      <!-- 退货合同产品明细 -->
      <ReturnProductDetail v-if="getPageTitle === '退货合同(已发货)'||getPageTitle === '退货合同(未发货)'" :title="getPageTitle" :data="ReturnProductDetailData" />
      <!-- 换货合同产品明细 -->
      <barterConttractProductDetail v-if="getPageTitle === '换货合同' || getPageTitle === '价外费用合同' || getPageTitle === '虚拟换货合同'" :title="getPageTitle" :table-data="exchangeTableData" :address="address" />
      <!-- 罚金合同产品明细 -->
      <PenaltyDetail v-if="getPageTitle === '罚金合同'" :title="getPageTitle" :table-data="exchangeTableData" />
      <!-- 附件说明 -->
      <Attachments :table-data="AttachmentsData" />
    </div>
    <div class="footer">
      <el-button type="default" class="btn-style" @click="back">
        返回
      </el-button>
    </div>
  </div>
</template>
<script>
import BaseInfo from './components/baseInfo.vue';
import Attachments from './components/attachments.vue';
import ReturnProductDetail from './components/returnProductDetails.vue';
import barterConttractProductDetail from './components/barterConttractProductDetail.vue';
import PenaltyDetail from './components/penaltyDetails.vue';
import { getDoneReturnDetailData, getDoneReplacementDetailData } from '@/API';
import { getReceiptInterAddressByContractId } from '@/API/international';

export default {
  data () {
    return {
      baseInfoFormData: {},
      customer: {},
      detail: {},
      // 退货合同列表数据
      ReturnProductDetailData: {
        address: '',
        receiverName: '',
        telephone: '',
        tableData: []
      },
      // 换货合同表格数据
      exchangeTableData: [],
      // 附件说明数据
      AttachmentsData: [],
      address: {}
    };
  },
  components: {
    BaseInfo,
    Attachments,
    ReturnProductDetail,
    barterConttractProductDetail,
    PenaltyDetail
  },
  computed: {
    getPageTitle () {
      return this.$route.query.contractType;
    }
  },
  mounted () {
    this.doSearch();
  },
  methods: {
    // 查询详情
    async doSearch () {
      const parmas = {
        contractId: this.$route.query.contractId
      };
      try {
        let res;
        if (this.$route.query.contractType.includes('退货合同')) {
          res = await getDoneReturnDetailData(parmas);
        } else {
          res = await getDoneReplacementDetailData(parmas);
        }
        const json = res.data;
        if (json.status === '200') {
          this.detail = json.data.detail;
          this.baseInfoFormData = json.data.base;
          this.customer = json.data.customer;
          this.ReturnProductDetailData.tableData = json.data.product;
          this.exchangeTableData = json.data.product;
          this.AttachmentsData = json.data.attachment;
          this.Address(json.data.base.id);
        }
      } catch (error) {
        // 错误处理
      }
    },
    // 获取收货地址
    Address (id) {
      getReceiptInterAddressByContractId(id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.ReturnProductDetailData.address = json.data.receiptAddress;
          this.ReturnProductDetailData.receiverName = json.data.receiverName;
          this.ReturnProductDetailData.telephone = json.data.receiverPhone;
          this.address = json.data;
        }
      }).catch(() => {

      });
    },
    back () {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.exchange-container {
  position: relative;
  .tip-title {
    position: sticky;
    top: 0px;
    left: 0px;
    z-index: 99;
    width: 100%;
    height: 56px;
    line-height: 56px;
    margin-top: -15px;
    color: #424C57;
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    background-color: #fff;
    box-shadow: 0px 4px 4px 0px rgba(3, 18, 41, 0.05);
  }
  .footer{
    width: 100%;
    height: 60px;
    line-height: 60px;
    margin-top: 12px;
    background-color: #fff;
    box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.05);
    text-align: center;
    .btn-style{
      width: 120px;
      height: 42px;
      font-size: 16px;
    }
  }
}
</style>
